export default __webpack_public_path__ + "static/media/gameOver.fd000b5b.wav";